import React, { useState, useEffect } from "react";
import UserPanel from "../Dashboard/UserPanel";
import {
  Container,
  Row,
} from "reactstrap";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { useMachine } from "../../context/MachineContext";

const TraceabilityQc = () => {
  const authToken = localStorage.getItem("access");
  const location = useLocation();
  const navigate = useNavigate();
  const machine = location.state?.part;
  const [machines, setMachines] = useState([]);
  const [submittedAssemblies, setSubmittedAssemblies] = useState([]);
  const [selected, setSelected] = useState([]);
  const [boxNumbers, setBoxNumbers] = useState({});
  const selectedOperator_name = localStorage.getItem('name');
  const selectedOperator_id = localStorage.getItem('id');
  const selectedMachineId = localStorage.getItem('selectedMachineId');
  const [selectedMachine, setSelectedMachine] = useState(machine?.machine_id || selectedMachineId);
  const [operators, setOperators] = useState([]);
  const [childPartData, setChildPartData] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [usedDetails, setUsedDetails] = useState([]);
  const [qcData, setQcData] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);

  useEffect(() => {
    fetchMachine();
  }, []);

  const fetchMachine = async () => {
    try {
      const response = await fetch("https://api.hanoch.in/api/machines");
      if (response.ok) {
        const machines = await response.json();
        setMachines(machines?.data);
      } else if (response.status === 401) {
        localStorage.removeItem("access");
      } else {
        console.error("Error fetching data:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const selectedMachineObject = machines.find(m => m.id == selectedMachine);
  const isManual = selectedMachineObject?.manual ?? false;
  const selectedChildPart = selectedMachineObject?.parts;

  const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  const [selectedDate, setSelectedDate] = useState(() => machine?.date || getTodayDate());

  const isShiftDisabled = (shift) => {
    const now = new Date();
    const currentHour = now.getHours();

    if (shift === "1") {
      return currentHour < 6;
    } else if (shift === "2") {
      return currentHour < 14;
    } else if (shift === "3") {
      return currentHour < 22 && currentHour >= 6;
    }
    return false;
  };

  const getCurrentShift = () => {
    const now = new Date();
    const hours = now.getHours();
    if (hours >= 6 && hours < 14) {
      return 1;
    } else if (hours >= 14 && hours < 22) {
      return 2;
    } else {
      return 3;
    }
  };
  const [selectedShift, setSelectedShift] = useState(() => machine?.shift || getCurrentShift());

  const handleDateChange = (event) => {
    const newDate = event.target.value;
    setSelectedDate(newDate);
    setBoxNumbers({});
  };
  const handleMachineChange = (event) => {
    const machineId = event.target.value;
    setSelectedMachine(machineId);
    setBoxNumbers({});
  };
  const handleShiftChange = (event) => {
    const newShift = event.target.value;
    setSelectedShift(newShift);
    setBoxNumbers({});
  };

  const fetchUsedDetails = async () => {
    try {
      setIsLoading(true);
      const res = await fetch(
        `https://api.hanoch.in/api/readyforqc/list/?part_id=${selectedChildPart}`
      );
      if (!res.ok) throw new Error("Failed to fetch used details");
      const usedDetails = await res.json();
      setUsedDetails(usedDetails);
    } catch (err) {
      console.error(err);
    }finally{
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (selectedShift && selectedDate && selectedChildPart) {
      fetchUsedDetails();
    }
  }, [selectedChildPart, selectedDate, selectedShift,selectedMachine]);

  // Toggle button instead of checkbox
  const handleToggleSelect = (item) => {
    if (selected.find((x) => x.id === item.id)) {
      setSelected(selected.filter((x) => x.id !== item.id));
    } else {
      setSelected([...selected, item]);
    }
  };

  const handleSubmit = async() => {
    if (selected.length === 0) {
      alert("No boxes selected!");
      return;
    }
 // Merge all selected part_label arrays into one big array
  const allBoxSerials = selected
    .map(row => row.part_label) // get each row's part_label array
    .flat() // flatten into a single array
    .join(","); // convert to comma-separated string
    const payload = {
    operator: selectedOperator_id, // from your state
    part: selectedChildPart, // from your state
    box_serials:allBoxSerials, // convert array to comma-separated
    date: selectedDate, // from your state
    shift: selectedShift, // from your state
    machine: selectedMachineId,
   
  };

  console.log("Payload:", payload);
 try {
  setIsLoading(true);
    await axios.post(
      "https://api.hanoch.in/api/traceabilityassemblyqc/",
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          // Authorization: `Bearer ${authToken}`,
        },
      }
    );
    alert("Data submitted successfully!");
    setSelected([]);
    fetchUsedDetails();
  } catch (err) {
    console.error("Error:", err);
  } finally{
    
setIsLoading(false);
  }
};

  document.title = "Part Assembly | OptiMize ";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="OptiMize" breadcrumbItem="Traceability QC" />

          {/* Filters */}
          <div className="d-flex flex-wrap align-items-center mb-3" style={{ gap: "12px", padding: "12px 16px", backgroundColor: "#252b3b", color: "#c9d1d9", borderRadius: "6px", width: "100%" }}>
            <div className="d-flex align-items-center">
              <label style={{ fontSize: "13px", marginRight: "6px", marginBottom: 0, color: "#8b949e" }}>Select Machine:</label>
              <select className="form-control" value={selectedMachine || ""} onChange={handleMachineChange}>
                <option key="default">Select Machine</option>
                {machines?.map((machine, index) => (
                  <option key={index} value={machine.id}>
                    {machine.name}
                  </option>
                ))}
              </select>
            </div>

            <div style={{ backgroundColor: "#21262d", padding: "4px 10px", borderRadius: "6px", border: "1px solid #30363d" }}>
              <span style={{ fontWeight: "600", fontSize: "16px" }}>{selectedChildPart}</span>
            </div>

            <div className="d-flex align-items-center">
              <label style={{ fontSize: "13px", marginRight: "6px", marginBottom: 0, color: "#8b949e" }}>Shift:</label>
              <select value={selectedShift} onChange={handleShiftChange} style={{ padding: "4px 8px", backgroundColor: "#21262d", color: "#c9d1d9", border: "1px solid #30363d", borderRadius: "6px", fontSize: "13px" }}>
                <option value="">Select shift</option>
                <option value="1" disabled={selectedDate === new Date().toISOString().split('T')[0] && isShiftDisabled("1")}>6-2 (Shift 1)</option>
                <option value="2" disabled={selectedDate === new Date().toISOString().split('T')[0] && isShiftDisabled("2")}>2-10 (Shift 2)</option>
                <option value="3" disabled={selectedDate === new Date().toISOString().split('T')[0] && isShiftDisabled("3")}>10-6 (Shift 3)</option>
              </select>
            </div>

            <div className="d-flex align-items-center">
              <label style={{ fontSize: "13px", marginRight: "6px", marginBottom: 0, color: "#8b949e" }}>Date:</label>
              <input type="date" value={selectedDate} onChange={handleDateChange} max={new Date().toISOString().split('T')[0]} style={{ padding: "4px 8px", backgroundColor: "#21262d", color: "#c9d1d9", border: "1px solid #30363d", borderRadius: "6px", fontSize: "13px" }} />
            </div>
          </div>

          {/* Table */}
          <div style={{ marginTop: "1rem" }}>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr>
                  <th style={{ border: "1px solid", padding: "8px" }}>Action</th>
                  <th style={{ border: "1px solid", padding: "8px" }}>ID</th>
                  <th style={{ border: "1px solid", padding: "8px" }}>Part Label</th>
                  <th style={{ border: "1px solid", padding: "8px" }}>Part Name (Description)</th>
                  <th style={{ border: "1px solid", padding: "8px" }}>Operator</th>
                </tr>
              </thead>
                {isLoading ? (
            <div className="text-center">
             loading........ please wait
            </div>
          ) : (
              <tbody>

                {usedDetails.map((detail) => (
                  <tr key={detail.id}>
                    <td style={{ border: "1px solid", padding: "8px" }}>
                      <button
                        onClick={() => handleToggleSelect(detail)}
                        style={{
                          padding: "5px 10px",
                          borderRadius: "4px",
                          border: "none",
                          backgroundColor: selected.some((x) => x.id === detail.id) ? "#28a745" : "#6c757d",
                          color: "white",
                          cursor: "pointer"
                        }}
                      >
                        {selected.some((x) => x.id === detail.id) ? "Selected" : "Select"}
                      </button>
                    </td>
                    <td style={{ border: "1px solid", padding: "8px" }}>{detail.id}</td>
                    <td style={{ border: "1px solid", padding: "8px" }}>{detail.part_label}</td>
                    <td style={{ border: "1px solid", padding: "8px" }}>{detail.part_name} ({detail.part_description})</td>
                    <td style={{ border: "1px solid", padding: "8px" }}>{detail.operator_name}</td>
                  </tr>
                ))}
              </tbody>
          )}
            </table>

            <div style={{ marginTop: "1rem" }}>
                {isLoading ? (
            <div className="text-center">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
              <button className="btn btn-primary waves-effect waves-light" onClick={handleSubmit}>
                Submit Selected
              </button>
          )}
            </div>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default TraceabilityQc;
